<style lang="scss" type="stylesheet/scss" scoped>
@import "@/assets/var.scss";

.favorite-wrapper {
  background: white;
  border-radius: 4px;
  .title {
    padding: 24px;
    font-size: 16px;
    color: #333;
    font-weight: bold;
  }
  .favorite-tabs {
    margin-top: 30px;
    padding: 0 24px 22px;
    border-bottom: solid 1px #eff3fa;
    .router-link {
      line-height: 20px;
      color: #666;
      text-decoration: none;
      margin-right: 40px;
      font-size: 14px;
      &.active {
        color: $mainBlue;
        font-weight: bold;
        position: relative;
        &:before {
          content: "";
          position: absolute;
          left: 50%;
          bottom: -24px;
          transform: translateX(-50%);
          width: 66px;
          height: 4px;
          background: $mainBlue;
        }
      }
      &:hover {
        color: $mainBlue;
        text-decoration: underline;
      }
    }
  }
}
</style>

<template>
  <div class="favorite-wrapper">
    <div class="title">我的收藏</div>
    <div class="favorite-tabs">
      <router-link class="router-link"
                   :class="{active:$route.name === 'Favorite-Product'}"
                   to="product">收藏的产品</router-link>
      <router-link class="router-link"
                   :class="{active:$route.name === 'Favorite-Shop'}"
                   to="shop">收藏的店铺</router-link>
    </div>
    <router-view />
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "favorite",
  data() {
    return {};
  },
};
</script>
